import clsx from 'clsx'

/* assets */
import { ReactComponent as ElevateLogoIcon } from 'public/assets/elevate-generative-ai/icons/elevate.svg'

interface Props {
  alignment?: 'horizontal' | 'vertical'
  showName?: boolean
  className?: string
  logoClassName?: string
}

function ElevateLogo({
  alignment = 'horizontal',
  showName = true,
  className,
  logoClassName
}: Props): JSX.Element {
  return (
    <div
      className={clsx(
        'flex items-center',
        alignment === 'vertical' ? 'flex-col' : 'gap-1',
        className
      )}
    >
      <ElevateLogoIcon className={logoClassName} viewBox="0 0 196 92" />
      {showName && (
        <span
          className={clsx(
            'text-xs font-semibold | relative',
            alignment === 'vertical' ? '-top-2' : ''
          )}
        >
          by Peppercontent
        </span>
      )}
    </div>
  )
}

export default ElevateLogo
